import { Box, BoxProps, Divider, Stack, VStack } from "@chakra-ui/react"
import { Field, FieldProps, FormikProps, FormikValues } from "formik"
import { FormInputField } from "../../../components/formInputField/FormInputField";
import { FormSubSectionHeader } from "../../../components/formSubSectionHeader/FormSubSectionHeader";
import { IFormDataClassField } from "../../../utils/formsSchema/FormDataClass"

interface Props {
    fields: Record<string, IFormDataClassField>;
    formik: FormikProps<FormikValues>;
    defaultValues: Record<string, any>;
  }

export const GamCampaignIds = ({
    formik,
    fields,
    defaultValues,
    ...boxProps
}: Props & BoxProps) => {

    const {
        orderId,
        learnFromIds,
    } = fields;

    return (
        <Box {...boxProps}>
            <FormSubSectionHeader label={"Campaign IDs"} />
            <Divider mt={0} mb={4} />
            <Stack align={"flex-start"} width={"100%"} direction="row">
                <VStack w="100%">
                    <Field name={"orderId"}>
                        {({ field, form }: FieldProps) => (
                            <FormInputField
                                mt={0}
                                inputFieldProps={{
                                ...field,
                                variant: "greyInput",
                                }}
                                fieldType={"text"}
                                isRequired={orderId.isRequired}
                                label={orderId.label}
                                isInvalid={!!(form.errors.orderId && !!form.touched.orderId)}
                                placeholder={orderId.placeholder}
                                errorMessage={form.errors?.orderId?.toString()}
                            />
                        )}
                    </Field>
                    <Field name={"learnFromIds"}>
                        {({ field, form }: FieldProps) => (
                            <FormInputField
                                mt={0}
                                inputFieldProps={{
                                ...field,
                                variant: "greyInput",
                                }}
                                fieldType={"text"}
                                isRequired={learnFromIds.isRequired}
                                label={learnFromIds.label}
                                isInvalid={!!(form.errors.learnFromIds && !!form.touched.learnFromIds)}
                                placeholder={learnFromIds.placeholder}
                                errorMessage={form.errors?.learnFromIds?.toString()}
                            />
                        )}
                    </Field>
                </VStack>
            </Stack>
        </Box>
    )
}
